"use client";

import { SiteTemplatePageSectionTypeHelpDefaultListItemSettingModel } from "@/Apis/ClinicApi";
import { HelpSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import HomeEighteenHelpSectionGenerated, {
  HomeEighteenHelpSectionGeneratedProps,
} from "../Sections/_generated/HomeEighteenHelpSection.generated";
import { buildGeneratedSectionProps } from "./generated-section-renderer";

function getHelpItems(
  props: HelpSectionProps,
): SiteTemplatePageSectionTypeHelpDefaultListItemSettingModel[] {
  return props.lists.Default ?? [];
}

const GeneratedHelpSection: FC<HelpSectionProps> = (props) => {
  const defaults =
    buildGeneratedSectionProps<HomeEighteenHelpSectionGeneratedProps>(
      "HomeEighteenHelpSection",
    );
  const configuredItems = getHelpItems(props);

  const helpItems =
    configuredItems.length > 0
      ? configuredItems.map((item, index) => {
          const baseItem =
            defaults.helpSectionTitles[
              index % defaults.helpSectionTitles.length
            ] ?? defaults.helpSectionTitles[0];

          return {
            ...baseItem,
            key: item.Id,
            divText: item.TitleBeforeImage ?? baseItem?.divText ?? "",
            divDivText: item.TitleAfterImage ?? baseItem?.divDivText ?? "",
            src: item.Image?.Url ?? baseItem?.src ?? "",
            alt: item.Image?.AltText ?? baseItem?.alt ?? "help-img",
          };
        })
      : defaults.helpSectionTitles;

  return (
    <HomeEighteenHelpSectionGenerated
      {...defaults}
      helpSectionTitles={helpItems}
    />
  );
};

export default GeneratedHelpSection;
